<template>
  <anchor-card-base-view :outlined="true" :title="title" class="flex">
    <template slot="title-helper">
      <div>
        <v-btn
          x-small
          color="secondary"
          :disabled="disabled"
          @click="$emit('download-all', payload.files)"
        >
          Download All Files
        </v-btn>
        <v-btn
          x-small
          color="secondary"
          class="ml-2"
          @click="expandAllHandler"
        >
          Expand All Folders
        </v-btn>
        <v-btn
          x-small
          color="secondary"
          class="ml-2"
          @click="panel = []"
        >
          Collapse All Folders
        </v-btn>
      </div>
    </template>

    <v-skeleton-loader
      type="list-item@10"
      :loading="loading"
    >
      <v-expansion-panels accordion multiple v-model="panel">
        <anchor-base-insight-expansion-panel
          v-for="(category, idx) in payload.files"
          :key="idx"
          :title="category.title"
        >
          <template v-slot:actions>
            <v-spacer />
            <small>
              <div class="grey--text text-right">
                <div class="py-1">
                  {{ category.files.length }} {{ `Document${category.files.length === 1 ? '' : 's'}` }}
                </div>
                <div class="py-1">
                  Last Upload: {{ getLastUpload(category) | datetime }}
                </div>
              </div>
            </small>
          </template>
          <v-divider />
          <slot name="expander-content" v-bind:items="category">
            <anchor-files-table
              :payload="category"
            >
              <template v-slot:actions-column="item">
                <slot name="table-actions-column" v-bind:file="item"/>
              </template>
            </anchor-files-table>
          </slot>
        </anchor-base-insight-expansion-panel>
      </v-expansion-panels>
    </v-skeleton-loader>
  </anchor-card-base-view>
</template>

<script>
import AnchorCardBaseView from '../cards/view/BaseViewCard';

export default {
  name: 'AnchorFilesContainer',
  components: {
    AnchorCardBaseView,
  },
  props: {
    payload: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: 'Folders',
    },
  },
  data: () => ({
    panel: [],
  }),
  methods: {
    expandAllHandler() {
      this.panel = [...Array(this.$props.payload.files.length).keys()];
    },
    getLastUpload(category) {
      const sortedDates = category.files.map(file => new Date(file.createdOn)).sort();
      return sortedDates.length ? sortedDates[sortedDates.length - 1] : null;
    },
  },
};
</script>
